<template>
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper mt-2">
            <div class="datatable-header">
              <div class="row align-items-center mb-3">
                <div class="col-12 col-lg-auto mb-3">
                  <router-link
                    :to="{ name: 'AddCategory' }"
                    class="
                      btn btn-primary btn-md
                      font-weight-semibold
                      btn-py-2
                      px-4
                    "
                    >+ {{ translations.addCategory }}</router-link
                  >
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                  <!-- <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <div class="layout-modes">
                      <div
                        class="layout-btn btn-grid"
                        :class="{ active: displayMode === 'table' }"
                        @click="changeDisplayMode('table')"
                      >
                        <i class="bx bx-table"></i>
                      </div>
                      <div
                        class="layout-btn btn-list"
                        :class="{ active: displayMode === 'list' }"
                        @click="changeDisplayMode('list')"
                      >
                        <i class="bx bx-align-right"></i>
                      </div>
                    </div>
                  </div> -->
                </div>
                <!-- <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <label class="ws-nowrap me-3 mb-0">Show:</label>
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >{{ page }}</option>
                    </select>
                  </div>
                </div> -->
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="displayMode === 'table'">
              <div
                v-if="list.length > 0"
                id="datatable-ecommerce-list_wrapper"
                class="dataTables_wrapper dt-bootstrap5 no-footer"
              >
                <div class="row justify-content-between">
                  <div class="col-auto"></div>
                  <div class="col-auto"></div>
                </div>
                <div class="table-responsive">
                  <table
                    class="
                      table table-ecommerce-simple table-striped
                      mb-0
                      dataTable
                      no-footer
                    "
                    id="datatable-ecommerce-list"
                    style="min-width: 550px"
                    role="grid"
                    aria-describedby="datatable-ecommerce-list_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          width="3%"
                          class="sorting_disabled"
                          rowspan="1"
                          colspan="1"
                          aria-label=""
                          style="width: 17px"
                        >
                          <input
                            type="checkbox"
                            class="select-all checkbox-style-1 p-relative top-2"
                            v-model="selectAll"
                          />
                        </th>
                        <th
                          class="sorting"
                        >
                          Rbr
                        </th>
                        <th
                          class="sorting"
                        >
                          Naziv
                        </th>
                        <th
                          class="sorting"
                        >
                          Slug
                        </th>
                        <th
                          class="sorting"
                        >
                          Opis
                        </th>
                        <th class="sorting">Nadredjena kategorija</th>
                        <th class="sorting">Prioritet</th>
                        <th class="sorting">Datum kreiranja</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(category, index) in categories" :key="category.id" :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }">
                        <td width="30">
                          <input
                            type="checkbox"
                            class="checkbox-style-1 p-relative top-2"
                            :value="category.id"
                            v-model="selected"
                            @click.stop
                          />
                        </td>

                        <td>
                          <router-link :to="{ name: 'EditCategory', params: { id: category.id } }">
                            <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                          </router-link>
                        </td>

                        <td>
                          <router-link :to="{ name: 'EditCategory', params: { id: category.id } }">
                            {{ category.title }}
                          </router-link>
                        </td>

                        <td>
                          {{ category.slug || 'N/A' }}
                        </td>

                        <td class="text-hidden" :title="category.description">
                          {{ category.description || 'N/A' }}
                        </td>

                        <td>
                          <router-link :to="{ name: 'EditCategory', params: { id: category.parentCategoryId } }">
                            {{ category.parentCategory }}
                          </router-link>
                        </td>
                        <td>
                          {{ category.order }}
                        </td>
                        <td>{{ formatDate(category.createdDate) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div class="datatable-footer">
                <div class="row align-items-center justify-content-between mt-3">
                  <div class="col-md-auto order-1 mb-3 mb-lg-0">
                    <div class="d-flex align-items-stretch">
                      <div
                        class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                      >
                        
                        <select
                          class="form-control select-style-1 bulk-action"
                          name="bulk-action"
                          v-model="bulkAction"
                          style="min-width: 170px"
                        >
                          <option value="bulkAction">Bulk Actions</option>
                          <option value="delete">Delete</option>
                        </select>

                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-modal"
                          class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
                          {{ translations.apply }}
                        </button>

                      </div>
                    </div>
                  </div>
                  <!-- <div class="row row-gutter-sm justify-content-between mt-4">
                    <pagination :action="actionName" />
                  </div> -->
                </div>
              </div>
            </div>
            <div v-else>
              <div class="categories">
                ok {{ categoriesTreeView }} here
                <div v-for="item in categoriesTreeView" :key="item.id">
                  <div
                    class="category-wrapper lvl-1"
                    :class="{ 'has-child': item.children && item.children.length > 0 }"
                    @click.prevent.stop="toggleCategory(item)"
                  >
                    <img
                      class="thumbnail"
                      v-if="item.imageUrl"
                      :src="`${baseUrl}${item.imageUrl}`"
                      :alt="item.title"
                    />

                    <img
                      class="thumbnail"
                      v-else
                      src="img/products/product-8.jpg"
                      :alt="item.title"
                    />
                    <div>
                      <router-link
                        class="category-name"
                        :to="{ name: 'EditCategory', params: { id: item.id } }"
                      >
                        {{ item.label }}
                      </router-link>

                      <div>
                        Broj direktno vezanih kategorija:
                        {{ item.children ? item.children.length : 0 }}
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="item.childVisible && item.children && item.children.length > 0"
                    v-for="child in item.children"
                    :key="child.id"
                  >
                    <div
                      class="category-wrapper lvl-2"
                      :class="{ 'has-child': child.children && child.children.length > 0 }"
                      @click.prevent.stop="toggleCategory(child)"
                    >
                      <img
                        class="thumbnail"
                        v-if="child.imageUrl"
                        :src="`${baseUrl}${child.imageUrl}`"
                        :alt="child.title"
                      />

                      <img
                        class="thumbnail"
                        v-else
                        src="img/products/product-8.jpg"
                        :alt="child.title"
                      />
                      <div>
                        <router-link
                          class="category-name"
                          :to="{ name: 'EditCategory', params: { id: child.id } }"
                        >
                          {{ child.label }}
                        </router-link>

                        <div>
                          Broj direktno vezanih kategorija:
                          {{ child.children ? child.children.length : 0 }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        child.childVisible && child.children && child.children.length > 0
                      "
                      v-for="subChild in child.children"
                      :key="subChild.id"
                    >
                      <div class="category-wrapper lvl-3">
                        <img
                          class="thumbnail"
                          v-if="subChild.imageUrl"
                          :src="`${baseUrl}${subChild.imageUrl}`"
                          :alt="subChild.title"
                        />

                        <img
                          class="thumbnail"
                          v-else
                          src="img/products/product-8.jpg"
                          :alt="subChild.title"
                        />
                        <router-link
                          class="category-name"
                          :to="{ name: 'EditCategory', params: { id: subChild.id } }"
                        >
                          {{ subChild.label }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
      <div slot="body">
        <span v-html="modalText">
        </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import { translations, pager } from '@/mixins';
import config from "@/config";
import Pagination from '@/components/shared/Pagination.vue';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'Categories',
  // eslint-disable-next-line vue/no-unused-components
  components: { Pagination, Modal },
  mixins: [translations, pager],
  data() {
    return {
      actionName: 'getCategories',
      deleteActionName: 'deleteCategories',
      bulkActionName: 'deleteCategories',
      displayMode: 'table', // Also can be list
    };
  },
  computed: {
    list() {
      return this.$store.getters.getCategories;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    categories() {
      return sortBy(this.list, ['parentCategoryId']);
    },
    categoriesTreeView() {
      return this.$store.getters.getCategoriesTree;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  methods: {
    changeDisplayMode(mode) {
      this.displayMode = mode;
    },
    toggleCategory(category) {
      this.$store.commit("CHANGE_VISIBILITY", category.id);
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, {
      ...this.searchConfig,
      retrieveAll: true,
    });
  },
};
</script>

<style lang="scss" scoped>
.text-hidden {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 500px;
}

.layout-modes {
  display: flex;
  flex-direction: row;

  .layout-btn {
    padding: 5px;
    font-size: 1.5rem;
    cursor: pointer;

    &.active {
      color: #08c;
    }
  }
}

.categories {
  padding-top: 10px;
}

.category-wrapper {
  display: flex;
  max-width: 100%;
  padding: 5px;
  border: 1px solid #777;
  margin-top: 2px;
  border-radius: 5px;
  min-height: 60px;

  > * {
    margin: 10px;
  }

  &.has-child {
    cursor: pointer;
  }
}

.lvl-2 {
  margin-left: 20px;
}

.lvl-3 {
  margin-left: 40px;
}

.thumbnail {
  height: 80px;
  width: 80px;
  border: 1px solid #777;
  border-radius: 5px;
}
</style>